'use client';

import type { PropsWithChildren } from 'react';
import type { Collection } from '@/app/actions/collection';
import type { SportType } from '~/model/SportType';
import { createContext, useContext } from 'react';
import { useSports } from '@/app/hooks/useSports';

const SportsContext = createContext<ReturnType<typeof useSports> | undefined>(undefined);

export const useSportsContext = () => {
  const context = useContext(SportsContext);
  if (!context) {
    throw new Error(
      'useSportsContext must be called within SportsProvider',
    );
  }
  return context;
};

export function SportsProvider({
  children,
  sports,
}: PropsWithChildren<{
  sports: Collection<SportType>;
}>) {
  const value = useSports({ sports });

  return (
    <SportsContext.Provider value={value}>
      {children}
    </SportsContext.Provider>
  );
}
